import { useOrgListData } from 'auth'
import BrandLogo from 'components/brandLogo'
import { ArrowBackRounded } from 'components/icons'
import { useNavigate } from 'react-router-dom'
import { SizableText, View, XStack } from 'tamagui'

/**
 * Minimal app shell for the cross-org / person-level surfaces (`/admin`, `/affiliate`)
 * that live outside the org chrome. Brand + page title + "back to app".
 */
export default function PageShell({ title, children }: { title: string; children: React.ReactNode }) {
    const navigate = useNavigate()
    const { orgListUserData } = useOrgListData()
    const defaultOrg = Object.keys(orgListUserData.orgData)[0]
    const goBack = () => navigate(defaultOrg ? `/${defaultOrg}` : '/')

    return (
        <View
            flexDirection="column"
            height="100vh"
        >
            <XStack
                alignItems="center"
                gap="$3"
                height={64}
                flexShrink={0}
                paddingHorizontal="$5"
                $sm={{ paddingHorizontal: '$3' }}
                borderBottomWidth={1}
                borderBottomColor="$borderColor"
                backgroundColor="$backgroundStrong"
            >
                <XStack
                    alignItems="center"
                    cursor="pointer"
                    onPress={goBack}
                >
                    <BrandLogo />
                </XStack>
                <SizableText
                    fontSize="$5"
                    fontWeight="600"
                    marginLeft="$2"
                >
                    {title}
                </SizableText>
                <View flex={1} />
                <XStack
                    alignItems="center"
                    gap="$1.5"
                    cursor="pointer"
                    hoverStyle={{ opacity: 0.8 }}
                    onPress={goBack}
                >
                    <ArrowBackRounded
                        size={16}
                        color="$colorSoft"
                    />
                    <SizableText
                        fontSize="$3"
                        color="$colorSoft"
                    >
                        Back to app
                    </SizableText>
                </XStack>
            </XStack>
            <View
                flex={1}
                overflow="auto"
                padding="$5"
                $sm={{ padding: '$3' }}
            >
                {children}
            </View>
        </View>
    )
}
